import { useEffect, useReducer, useState } from 'react';
import type { PageFetcher } from './paged-items';
import { PagedItems } from './paged-items';

/**
 * React binding for `PagedItems`. A new `key` (e.g. source + category)
 * discards the cache and starts over.
 */
export function usePagedItems<T>(key: string, fetchPage: PageFetcher<T>, pageSize = 100): PagedItems<T> {
  const [, rerender] = useReducer((count: number) => count + 1, 0);
  const [state, setState] = useState(() => ({ key, items: new PagedItems(fetchPage, rerender, pageSize) }));
  let current = state;
  if (state.key !== key) {
    current = { key, items: new PagedItems(fetchPage, rerender, pageSize) };
    setState(current);
  }
  const items = current.items;
  useEffect(() => {
    items.setActive(true);
    items.ensure(0, pageSize - 1);
    return () => items.setActive(false);
  }, [items, pageSize]);
  return items;
}
